import React from 'react'

import './styles.scss'

const Rating = ({ flow_tag }) => {
	const renderTitle = () => {
		switch (flow_tag) {
			case '33': {
				return 'Just one photo and you’re cartoon character'
			}
			case '55': {
				return 'Change your photo. Horrify them all'
			}
			default: {
				return 'Just one photo and you’re a star'
			}
		}
	}

	return (
		<div className="rating">
			<h1
				className={`rating__heading ${
					flow_tag === '33' ? 'rating__heading--cartoonify' : ''
				}`}
			>
				{renderTitle()}
			</h1>

			<div className="rating__stars">
				<img src="/images/home/stars-min.png" alt="stars" />
				<span>Trusted by over 5 million people</span>
			</div>
		</div>
	)
}

export { Rating }
